module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Picture-c08041c8265efecdfd770dd8f5fcc363.svg";